import _ from "lodash";
import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Container, Form, Grid } from "semantic-ui-react";

import StudyStatus from "../../../data/enums/StudyStatus";
import "../../../static/priestProfile.css";
import BoldFM from "../../../util/styledMessages/BoldFM";
import ItalicFM from "../../../util/styledMessages/ItalicFM";
import StudyStatusDropdown from "../StudyStatusDropdown";
import UncertainCheckbox from "../priest-data-uncertain-check/UncertainCheckbox";
import UncertainIcon from "../priest-data-uncertain-check/UncertainIcon";

interface IPriestGeneralDataStudyStatusRowProps {
    labelName: string;
    data: StudyStatus | "all" | "";
    isGrey?: boolean;
    editMode: boolean;
    setPriest(labelName: string, value: any): any;
    uncertain?: boolean;
}

const PriestGeneralDataStudyStatusRow: React.FC<IPriestGeneralDataStudyStatusRowProps> = (props: IPriestGeneralDataStudyStatusRowProps) => {
    const { labelName, data, editMode, isGrey, setPriest, uncertain } = props;

    const handleStudyStatusChange = (_event: any, data: { value: StudyStatus }) => {
        const value = data.value;
        setPriest(labelName, value);
    };

    const handleUncertainChange = () => {
        setPriest("uncertainFields", labelName);
    };

    return (
        <Grid.Row id={isGrey ? "grey" : ""}>
            <Grid.Column align="center" className="text">
                <BoldFM id={"profile." + labelName} showColon />
            </Grid.Column>
            <Grid.Column className="text" name={labelName}>
                {editMode ? (
                    <Form.Group inline style={{ display: "flex", alignItems: "center" }} unstackable>
                        <Form.Field width={13}>
                            <StudyStatusDropdown defaultValue={data} displayOptionForAll={false} setValue={handleStudyStatusChange} />
                        </Form.Field>
                        {!_.isNil(uncertain) && !_.isNil(handleUncertainChange) && (
                            <UncertainCheckbox handleUncertainChange={handleUncertainChange} uncertain={uncertain} />
                        )}
                    </Form.Group>
                ) : data ? (
                    <Container>
                        <FM id={"profile.studyStatus." + data} />
                        {uncertain && <UncertainIcon />}
                    </Container>
                ) : (
                    <ItalicFM id="general.noData" />
                )}
            </Grid.Column>
        </Grid.Row>
    );
};

export default PriestGeneralDataStudyStatusRow;
